import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import getEnvelopeBody from './getEnvelopeBody';
import { appendQueryParameters } from './location';
import parseJSON from '../json/parseJson';
import responseHandler from './responseHandler';

var rnoContent = function rnoContent(method) {
  return /^(?:GET|HEAD)$/i.test(method);
};

var defaultOptions = {
  method: 'GET',
  headers: {}
};
/**
 * XMLHttpRequest transport
 */

export default function xhr(o) {
  return new Promise(function (resolve, reject) {
    var options = _objectSpread(_objectSpread({}, defaultOptions), o);

    var method = options.method || 'GET';
    var hasContent = !rnoContent(method);
    var headers = options.headers || {};
    var request = new XMLHttpRequest();
    var url = options.url || window.location.href;

    if (!options.envelope && !hasContent && options.data) {
      url = appendQueryParameters(url, options.data);
    }

    if (options.envelope) {
      url = appendQueryParameters(url, {
        envelope: 'request'
      });
    }

    request.open(options.envelope ? 'POST' : method, url, true);

    request.onreadystatechange = function () {
      if (request.readyState === 4) {
        var response = parseJSON(request.responseText);
        responseHandler(request.status, response).then(function (result) {
          return resolve(result);
        }).catch(function (err) {
          return reject(err);
        });
      }
    };

    if (options.envelope) {
      request.send(getEnvelopeBody(method, headers, options.data));
      return;
    }

    Object.keys(headers).forEach(function (header) {
      if (Object.prototype.hasOwnProperty.call(headers, header)) {
        request.setRequestHeader(header, headers[header]);
      }
    });

    if (hasContent && options.data) {
      request.setRequestHeader('Content-Type', 'application/json');
      request.send(JSON.stringify(options.data));
    } else {
      request.send();
    }
  });
}
//# sourceMappingURL=xhr.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/web-sdk/dist/esm/net/xhr.js
// module id = 335
// module chunks = 0 1